import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Alert } from '@/shared/components/ui/common/Alert';
import { Badge } from '@/shared/components/ui/common/Badge';
import { Button } from '@/shared/components/ui/common/Button';
import { DialogLayout } from '@/shared/components/ui/layouts/DialogLayout';
import { formatTelefoneComCodigoPais, isCanalTelefone, isValidTelefone } from '@/shared/utils/contato';
import { FeatherCreditCard } from '@subframe/core';
import { FeatherFileText } from '@subframe/core';
import { FeatherInfo } from '@subframe/core';
import { FeatherLink } from '@subframe/core';
import { FeatherMessageCircle } from '@subframe/core';
import { FeatherSend } from '@subframe/core';
import { FeatherUser } from '@subframe/core';
interface ModalReenvioProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  destinatario: string;
  canal: string;
  canalDestino?: string;
  titulo: string;
  corpo: string;
  link: string;
  rodape: string;
  anexos: string[];
  custoCreditos?: number;
  isLoading?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}
export const ModalReenvio = t0 => {
  const $ = _c(82);
  const {
    open,
    onOpenChange,
    destinatario,
    canal,
    canalDestino,
    titulo,
    corpo,
    link,
    rodape,
    anexos,
    custoCreditos: t1,
    isLoading: t2,
    onConfirmar,
    onCancelar
  } = t0;
  const custoCreditos = t1 === undefined ? 1 : t1;
  const isLoading = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== canal) {
    t3 = isCanalTelefone(canal);
    $[0] = canal;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const shouldFormatPhone = t3;
  let t4;
  if ($[2] !== canalDestino || $[3] !== shouldFormatPhone) {
    t4 = canalDestino && shouldFormatPhone && isValidTelefone(canalDestino) ? formatTelefoneComCodigoPais(canalDestino) : canalDestino;
    $[2] = canalDestino;
    $[3] = shouldFormatPhone;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const canalDestinoDisplay = t4;
  const canalDisplay = canalDestinoDisplay ? `${canal} (${canalDestinoDisplay})` : canal;
  let t5;
  if ($[5] !== destinatario || $[6] !== shouldFormatPhone) {
    t5 = shouldFormatPhone && isValidTelefone(destinatario) ? formatTelefoneComCodigoPais(destinatario) : destinatario;
    $[5] = destinatario;
    $[6] = shouldFormatPhone;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const destinatarioDisplay = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-heading-2 font-heading-2 text-default-font">Reenviar Notificação</span>;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FeatherUser className="text-body font-body text-brand-600" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== destinatarioDisplay) {
    t8 = <div className="flex items-center gap-2">{t7}<span className="text-body-bold font-body-bold text-default-font">Destinatário: {destinatarioDisplay}</span></div>;
    $[10] = destinatarioDisplay;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <FeatherMessageCircle className="text-body font-body text-brand-600" />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== canalDisplay) {
    t10 = <div className="flex items-center gap-2">{t9}<span className="text-body font-body text-default-font">Canal: {canalDisplay}</span></div>;
    $[13] = canalDisplay;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t8) {
    t11 = <div className="flex w-full flex-col items-start gap-2">{t6}<div className="flex w-full flex-col items-start gap-1">{t8}{t10}</div></div>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span className="text-heading-3 font-heading-3 text-default-font">Conteúdo que será reenviado</span>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span className="text-caption-bold font-caption-bold text-subtext-color">TÍTULO DA NOTIFICAÇÃO</span>;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== titulo) {
    t14 = <div className="flex w-full flex-col items-start gap-2">{t13}<span className="text-body-bold font-body-bold text-default-font">{titulo}</span></div>;
    $[20] = titulo;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <span className="text-caption-bold font-caption-bold text-subtext-color">CORPO DO TEXTO</span>;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== corpo) {
    t16 = <div className="flex w-full flex-col items-start gap-2">{t15}<span className="text-body font-body text-default-font">{corpo}</span></div>;
    $[23] = corpo;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <span className="text-caption-bold font-caption-bold text-subtext-color">LINK DE ACESSO</span>;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <FeatherLink className="text-body font-body text-brand-600" />;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== link) {
    t19 = <div className="flex w-full flex-col items-start gap-2">{t17}<div className="flex items-center gap-2">{t18}<a href={link} target="_blank" rel="noopener noreferrer" className="text-body font-body text-brand-600">{link}</a></div></div>;
    $[27] = link;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="text-caption-bold font-caption-bold text-subtext-color">RODAPÉ</span>;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  let t21;
  if ($[30] !== rodape) {
    t21 = <div className="flex w-full flex-col items-start gap-2">{t20}<span className="text-caption font-caption text-subtext-color">{rodape}</span></div>;
    $[30] = rodape;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  let t22;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <span className="text-caption-bold font-caption-bold text-subtext-color">ANEXOS</span>;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <FeatherFileText className="text-body font-body text-neutral-600" />;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] !== anexos[0]) {
    t24 = <span className="text-body font-body text-default-font">{anexos[0]}</span>;
    $[34] = anexos[0];
    $[35] = t24;
  } else {
    t24 = $[35];
  }
  let t25;
  if ($[36] !== anexos[1]) {
    t25 = <span className="text-caption font-caption text-subtext-color">{anexos[1]}</span>;
    $[36] = anexos[1];
    $[37] = t25;
  } else {
    t25 = $[37];
  }
  let t26;
  if ($[38] !== t24 || $[39] !== t25) {
    t26 = <div className="flex w-full flex-col items-start gap-2">{t22}<div className="flex items-center gap-3">{t23}<div className="flex flex-col items-start">{t24}{t25}</div></div></div>;
    $[38] = t24;
    $[39] = t25;
    $[40] = t26;
  } else {
    t26 = $[40];
  }
  let t27;
  if ($[41] !== t14 || $[42] !== t16 || $[43] !== t19 || $[44] !== t21 || $[45] !== t26) {
    t27 = <div className="flex w-full flex-col items-start gap-4">{t12}<div className="flex w-full flex-col items-start gap-4 rounded-md border border-solid border-neutral-200 bg-neutral-50 px-5 py-5">{t14}{t16}{t19}{t21}{t26}</div></div>;
    $[41] = t14;
    $[42] = t16;
    $[43] = t19;
    $[44] = t21;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <span className="text-heading-3 font-heading-3 text-default-font">Custo do Reenvio</span>;
    $[47] = t28;
  } else {
    t28 = $[47];
  }
  let t29;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <FeatherCreditCard className="text-heading-3 font-heading-3 text-brand-600" />;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  const t30 = custoCreditos > 1 ? "s" : "";
  const t31 = custoCreditos > 1 ? "is" : "";
  let t32;
  if ($[49] !== custoCreditos || $[50] !== t30 || $[51] !== t31) {
    t32 = <span className="text-body-bold font-body-bold text-default-font">O reenvio digital custa {custoCreditos} crédito{t30}{" "}adicional{t31}</span>;
    $[49] = custoCreditos;
    $[50] = t30;
    $[51] = t31;
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <span className="text-caption font-caption text-subtext-color">Este valor será debitado do seu saldo de créditos</span>;
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  let t34;
  if ($[54] !== t32) {
    t34 = <div className="flex shrink-0 grow basis-0 flex-col items-start gap-1">{t32}{t33}</div>;
    $[54] = t32;
    $[55] = t34;
  } else {
    t34 = $[55];
  }
  const t35 = custoCreditos > 1 ? "s" : "";
  let t36;
  if ($[56] !== custoCreditos || $[57] !== t35) {
    t36 = <Badge variant="brand">{custoCreditos} crédito{t35}</Badge>;
    $[56] = custoCreditos;
    $[57] = t35;
    $[58] = t36;
  } else {
    t36 = $[58];
  }
  let t37;
  if ($[59] !== t34 || $[60] !== t36) {
    t37 = <div className="flex w-full flex-col items-start gap-3">{t28}<div className="border-brand-200 bg-brand-50 flex w-full items-center gap-3 rounded-md border border-solid px-4 py-4">{t29}{t34}{t36}</div></div>;
    $[59] = t34;
    $[60] = t36;
    $[61] = t37;
  } else {
    t37 = $[61];
  }
  let t38;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <Alert variant="neutral" icon={<FeatherInfo />} title="Avisos importantes" description={"\u2022 O conte\xFAdo reenviado ser\xE1 exatamente igual ao conte\xFAdo original\n\u2022 Nenhuma edi\xE7\xE3o pode ser feita no reenvio\n\u2022 Caso deseje alterar o conte\xFAdo, crie uma nova notifica\xE7\xE3o"} />;
    $[62] = t38;
  } else {
    t38 = $[62];
  }
  let t39;
  if ($[63] !== isLoading || $[64] !== onCancelar) {
    t39 = <Button variant="neutral-secondary" size="large" onClick={onCancelar} disabled={isLoading}>Cancelar</Button>;
    $[63] = isLoading;
    $[64] = onCancelar;
    $[65] = t39;
  } else {
    t39 = $[65];
  }
  let t40;
  if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <FeatherSend />;
    $[66] = t40;
  } else {
    t40 = $[66];
  }
  let t41;
  if ($[67] !== isLoading || $[68] !== onConfirmar) {
    t41 = <Button variant="brand-primary" size="large" icon={t40} onClick={onConfirmar} loading={isLoading}>Confirmar Reenvio</Button>;
    $[67] = isLoading;
    $[68] = onConfirmar;
    $[69] = t41;
  } else {
    t41 = $[69];
  }
  let t42;
  if ($[70] !== t39 || $[71] !== t41) {
    t42 = <div className="flex w-full items-center justify-end gap-3">{t39}{t41}</div>;
    $[70] = t39;
    $[71] = t41;
    $[72] = t42;
  } else {
    t42 = $[72];
  }
  let t43;
  if ($[73] !== t11 || $[74] !== t27 || $[75] !== t37 || $[76] !== t42) {
    t43 = <div className="bg-default-background flex h-full w-full flex-col items-start gap-6 px-12 py-12"><div className="flex w-full max-w-[576px] flex-col items-start gap-6">{t11}{t27}{t37}{t38}{t42}</div></div>;
    $[73] = t11;
    $[74] = t27;
    $[75] = t37;
    $[76] = t42;
    $[77] = t43;
  } else {
    t43 = $[77];
  }
  let t44;
  if ($[78] !== onOpenChange || $[79] !== open || $[80] !== t43) {
    t44 = <DialogLayout open={open} onOpenChange={onOpenChange}>{t43}</DialogLayout>;
    $[78] = onOpenChange;
    $[79] = open;
    $[80] = t43;
    $[81] = t44;
  } else {
    t44 = $[81];
  }
  return t44;
};